// extracted by mini-css-extract-plugin
export default {"divBanner":"About_divBanner__IRInS","collapse":"About_collapse__1Zve0","page":"About_page__Azo9c"};